import { SketchElement } from '@sketch/inspector'

/**
 * Build a tree used only for automatic right-click target selection.
 * Hidden elements and all their descendants are excluded.
 *
 * This is intentionally separate from the menu list tree because hidden
 * elements should still be explicitly selectable from the "Select" submenu.
 */
export function getAutoSelectableElements(
  elementsList: SketchElement[]
): SketchElement[] {
  return elementsList.reduce((acc: SketchElement[], element) => {
    if (
      element.isHidden ||
      element.isAncestorHidden ||
      element.isLocked ||
      element.isAncestorLocked
    ) {
      return acc
    }

    acc.push({
      ...element,
      children: getAutoSelectableElements(element.children),
    })

    return acc
  }, [])
}
